cb.define(['common/common_VM.Extend.js'], function (common) {

    var setCheckBoxEnum = function (data) {
        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }
    };


    var PM_pmc_pointpreferential_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            let mode = viewmodel.getParams().mode;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');

            const displayPrice = () => {
                //仅勾线下门店
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "lProductId": "id",
                        "sProductName": "cName",
                        "sProductCode": "code",
                        "dPrice": "fMarkPrice",
                        "sProductPicUrl": "url",
                        "cDescribe": "modelDescription"
                    };
                    let sku_refRetId = {
                        "lProductId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "dPrice": "fMarkPrice",
                        "sProductPicUrl": "productUrl",
                        "cDescribe": "specs"
                    };
                    viewmodel.get("pointPreferentialPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("pointPreferentialPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                } else {
                    let pro_refCode = "pmc_product";
                    let sku_refCode = "aa_productsku";
                    let pro_refRetId = {
                        "lProductId": "id",
                        "sProductName": "cName",
                        "sProductCode": "code",
                        "dPrice": "fSalePrice",
                        "sProductPicUrl": "url",
                        "cDescribe": "modelDescription"
                    };
                    let sku_refRetId = {
                        "lProductId": "productskus_id",
                        "sProductName": "productName",
                        "sProductCode": "productCode",
                        "sProductSkuName": "name",
                        "sProductSkuCode": "code",
                        "dPrice": "salePrice",
                        "sProductPicUrl": "productUrl",
                        "cDescribe": "specs"
                    };
                    viewmodel.get("pointPreferentialPro").getEditRowModel().get("sProductCode").setRefCode(pro_refCode, JSON.stringify(pro_refRetId));
                    viewmodel.get("pointPreferentialPro").getEditRowModel().get("sProductSkuCode").setRefCode(sku_refCode, JSON.stringify(sku_refRetId));
                }
            }


            viewmodel.on('afterLoadData', function (data) {/****/
                displayPrice();
              common.displayChannel(viewmodel, 'pointpreferential');
              common.hideNoStore(viewmodel);
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["1"]);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('applicableChannel').setValue(["0"]);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('applicableChannel').setValue(["0", "1"]);
                }

                if (this.get('applyOnlineChannel').getValue() == false) {
                    viewmodel.get("terminalType").setVisible(false);
                } else {
                    viewmodel.get("terminalType").setVisible(true);
                }

                if (this.get('applyOffLineChannel').getValue() == false) {
                    viewmodel.get('offLineStore').setVisible(false);
                    viewmodel.get('pointPreferentialStore').setVisible(false);
                } else {
                    viewmodel.get('offLineStore').setVisible(true);
                    if (this.get('offLineStore').getValue() == 1 || this.get('offLineStore').getValue() == 0) {
                        viewmodel.get('pointPreferentialStore').setVisible(false);
                    } else {
                        viewmodel.get('pointPreferentialStore').setVisible(true);
                    }
                }

                if (this.get('bMemberLevelAll').getValue() == 0) {
                    viewmodel.get('pointPreferentialMemberL').setVisible(true);
                } else {
                    viewmodel.get('pointPreferentialMemberL').setVisible(false);
                }

                /**InputNumber不为负数**/
                viewmodel.get("pointPreferentialPro").getEditRowModel().get('iPointNum').setState('min', 0);
                viewmodel.get("pointPreferentialPro").getEditRowModel().get('dNewPrice').setState('min', 0);
                viewmodel.get("pointPreferentialPro").getEditRowModel().get('lTypeNum').setState('min', 0);
                viewmodel.get("pointPreferentialPro").getEditRowModel().get('totalQuantity').setState('min', 0);

            });

            viewmodel.get('applicableChannel').on('afterValueChange', function (data) {
                viewmodel.get('terminalType').setVisible(false);
                viewmodel.get('offLineStore').setVisible(false);
                viewmodel.get('pointPreferentialStore').setVisible(false);
                viewmodel.get('applyOnlineChannel').setValue(false);
                viewmodel.get('applyOffLineChannel').setValue(false);
                for (var i = 0; i < data.value.length; i++) {
                    if (data.value[i].value == 0) {
                        viewmodel.get('terminalType').setVisible(true);
                        viewmodel.get('applyOnlineChannel').setValue(true);
                    }
                    if (data.value[i].value == 1) {
                        viewmodel.get('applyOffLineChannel').setValue(true);
                        viewmodel.get('offLineStore').setVisible(true);
                        if (viewmodel.get('promotionParams')) {
                            let userType = viewmodel.get('promotionParams').userType;
                            //超级管理员
                            if (userType != 0 && viewmodel.get('offLineStore').getValue() == 1) {
                                viewmodel.get('offLineStore').setValue(2);
                            }
                        }
                        if (viewmodel.get('offLineStore').getValue() == 1) {
                            viewmodel.get('pointPreferentialStore').setVisible(false);
                        } else {
                            viewmodel.get('pointPreferentialStore').setVisible(true);
                        }
                    }
                }
                displayPrice();
            });


            //买家范围控制事件
            viewmodel.get('bMemberLevelAll').on('afterValueChange', function (data) {
                if (data.value.value === '0') {
                    viewmodel.get("pointPreferentialMemberL").setVisible(true);
                } else {
                    viewmodel.get('pointPreferentialMemberL').setVisible(false);
                }
            });
            //线下门店控制事件
            viewmodel.get('offLineStore').on('afterValueChange', function (data) {
                if (data.value.value === '1') {
                    viewmodel.get("pointPreferentialStore").setVisible(false);
                } else {
                    viewmodel.get('pointPreferentialStore').setVisible(true);
                }
            });

            viewmodel.get("pointPreferentialPro").on('afterCellValueChange', function (args) {
                if (args.cellName == 'product') {
                    this.setCellValue(args.rowIndex, 'iProductType', 0);
                }
                if (args.cellName == 'productSku') {
                    this.setCellValue(args.rowIndex, 'iProductType', 1);
                }
            })
            viewmodel.on('batchModifySetFields', function (args) {
                debugger
                args.forEach((item, index) => {
                    if (item.fieldName === 'sProductCode' || item.fieldName === 'lTypeNum' || item.fieldName === 'totalQuantity') {
                        item.bCanModify = false;
                    } else if (item.fieldName === 'sProductPicUrl') {
                        item.bCanFilter = false;
                    } else if (item.fieldName === 'sProductSkuName') {
                        item.bCanFilter = true;
                    } else if (item.fieldName === 'sProductSkuCode') {
                        item.bCanModify = false;
                        item.bCanFilter = true;
                    }
                })
            })
            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                debugger
                let counts = viewmodel.get('pointPreferentialPro').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("pointPreferentialPro").deleteRows(rowIndexes);
            })

            viewmodel.get("pointPreferentialPro").on('afterCellValueChange', function (args) {
                if (args.cellName == 'sProductCode') {
                    this.setCellValue(args.rowIndex, 'iProductType', 0);
                }
                if (args.cellName == 'sProductSkuCode') {
                    this.setCellValue(args.rowIndex, 'iProductType', 1);
                }
            })

            viewmodel.get("pointPreferentialPro").on("beforeBrowse", function (data) {
                common.productReferBrowseSimple(viewmodel, data, "iProductType", "pointPreferentialPro");
                return true;
            });

            viewmodel.on('beforeSave', function (data) {
                var obj = JSON.parse(data.data.data);

                obj.terminalType = setCheckBoxEnum(obj.terminalType);

                if (this.get('applyOnlineChannel').getValue() == '1' && obj.terminalType == 0) {
                    cb.utils.alert('适用线上商城时，适用终端不可为空', 'warning');
                    return false;
                }

                if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() != '1' && this.get('pointPreferentialStore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('applyOffLineChannel').getValue() == '0') {
                    obj.offLineStore = 1;
                    // if (obj.bMemberLevelAll == 1) {
                    //     obj.bMemberLevelAll = 2;
                    // }
                } else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '1') {
                    obj.pointPreferentialStore = [];
                }

                if (this.get('bMemberLevelAll').getValue() == '0' && this.get('pointPreferentialMemberL').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('bMemberLevelAll').getValue() != '0') {
                    obj.pricePreferentialMemberL = [];
                }
                if (viewmodel.get('pointPreferentialPro').getRows() == '') {
                    cb.utils.alert('所选商品不能为空', 'warning');
                    return false;
                }else{
                  for(let j = 0; j < viewmodel.get('pointPreferentialPro').getRowsCount(); j++){
                    if (!viewmodel.get('pointPreferentialPro').getRows()[j].lProductId ) {
                      cb.utils.alert('第' + (j + 1) + '行请选择相应的商品信息', 'warning');
                      return false;
                    }
                    if(viewmodel.get('pointPreferentialPro').getCellValue(j,'iPointNum') <= 0){
                      cb.utils.alert('第' + (j+1) +'行 所需积分 必须大于0', 'warning');
                      return false;
                    }
                  }
                }

                // if (mode == 'add') {
                //     if (viewmodel.get('pStartDate').getValue() <= nowDates) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }
                if (viewmodel.get('pStartDate').getValue() >= viewmodel.get('pEndDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }

                data.data.data = JSON.stringify(obj);

            })
        }
    };
    try {
        module.exports = PM_pmc_pointpreferential_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_pointpreferential_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_pointpreferential_VM.Extend.js